import React, { useEffect } from 'react';
import { Menu, Icon, Tooltip } from 'antd';
import { alertActions } from '../actions/alert.actions';
import { connect } from 'react-redux';
import { useRouteMatch, Link } from 'react-router-dom';
import cn from 'classnames';
import { notificationConstants } from '../constants/notification.constants';

import { ReactComponent as RequestsIcon } from "../resource/RequestsIcon.svg";
import { ReactComponent as DocumentsIcon } from "../resource/DocumentsIcon.svg";
import { ReactComponent as OfficesIcon } from "../resource/OfficesIcon.svg";
import { ReactComponent as TasksIcon } from "../resource/TasksIcon.svg";
import { ReactComponent as CalendarIcon } from "../resource/CalendarIcon.svg";
import { ReactComponent as QuestionsIcon } from "../resource/QuestionsIcon.svg";
import { ReactComponent as InformationsIcon } from "../resource/InformationsIcon.svg";
import { ReactComponent as VotingIcon } from "../resource/VotingIcon.svg";
import { ReactComponent as DebtsIcon } from "../resource/DebtsIcon.svg";
import { ReactComponent as HousingStockIcon } from "../resource/HousingStockIcon.svg";
import { ReactComponent as StatisticIcon } from "../resource/StatisticIcon.svg";
import { ReactComponent as NewStatisticIcon } from "../resource/NewStatisticIcon.svg";
import { ReactComponent as GeargIcon } from "../resource/GeargIcon.svg";
import { ReactComponent as HeadsetIcon } from "../resource/HeadsetIcon.svg";
import { ReactComponent as BadgeIcon } from "../resource/BadgeIcon.svg";
import { ReactComponent as MeterIcon } from "../resource/MeterIcon.svg";
import { ReactComponent as CallHistoryIcon } from "../resource/HandSetIcon.svg";
import { ReactComponent as ShutdownsIcon } from "../resource/ShutdownsIcon.svg";
import { ReactComponent as AcceptanceIcon } from "../resource/RoomsAcceptanceIcon.svg";
import { statisticsPages } from "../constants/statisticsPages";
import {
  adminPaths,
  adminPathsRootWithoutFirstSlash,
} from '../containers/Administration/constants/paths';
import { ReactComponent as CarIcon } from '../resource/Car.svg';

import styles from './appbar.module.scss';

const computeMenuItemClassName = (pageName, appPage) => {
  return cn(styles.menu__item, {
    [styles.menu__item_selected]: pageName === appPage,
  });
};

const TabBar = (props) => {
  const match = useRouteMatch('/:appPage');
  let appPage = '/Requests';
  if (match !== null) {
    const {
      params: { appPage: appPageMatch },
    } = match;
    appPage = appPageMatch;
  }

  useEffect(() => {
    if (appPage) {
      props.dispatch(alertActions.clear());
      props.dispatch({
        type: notificationConstants.NOTIFICATION_CLEAR,
        payload: null,
      });
      props.dispatch({ type: 'APPBAR_SET_PAGE', payload: appPage });
    }
  }, [appPage]);

  const { appMode, userInfo } = props;

  const menuIconStyle = { fontSize: 32, color: 'transparent', marginRight: 0 };

  const getMenuItemClassName = (pageName) => {
    return computeMenuItemClassName(pageName, appPage);
  };

  return (
    <Menu
      style={{ textAlign: 'left', paddingLeft: '13px', lineHeight: '1em' }}
      selectedKeys={[appPage]}
      mode="horizontal"
      overflowedIndicator={
        <div className={styles.menu__item}>
          <div className={styles.content}>
            <span>...</span>
          </div>
        </div>
      }
    >
      {(appMode === 'Administrator' && (
        <Menu.Item
          key="Requests"
          className={styles.menu__item}
        >
          <Link to="/Requests">
            <Icon type="left" />
          </Link>
        </Menu.Item>
      )) ||
        (userInfo.AllowRequests && (
          <Menu.Item
            key="Requests"
            className={getMenuItemClassName('Requests')}
          >
            <Tooltip
              placement="bottom"
              title="Заявки"
            >
              <Link to="/Requests">
                <Icon
                  component={RequestsIcon}
                  style={menuIconStyle}
                />
              </Link>
            </Tooltip>
          </Menu.Item>
        ))}
      {userInfo.AllowStatistics &&
        appMode !== 'Administrator' && [
          // <Menu.Item
          //   key="Statistics"
          //   style={
          //     getMenuItemClassName('Statistics')
          //   }
          // >
          //   <Tooltip placement="bottom" title="Статистика">
          //     <Link to="/Statistics">
          //       <Icon component={StatisticIcon} style={menuIconStyle} />
          //     </Link>
          //   </Tooltip>
          // </Menu.Item>,

          //  <Menu.Item
          //     key="Statistics"
          //     className={getMenuItemClassName(statisticsPages.root)}
          //   >
          //     <Tooltip
          //       placement="bottom"
          //       title="Статистика 1"
          //     >
          //       <Link
          //         to={`/${statisticsPages.root}`}
          //         onClick={
          //           appPage === 'Statistics'
          //             ? (e) => e.preventDefault()
          //             : undefined
          //         }
          //       >
          //         <Icon
          //           component={NewStatisticIcon}
          //           style={menuIconStyle}
          //         />
          //       </Link>
          //     </Tooltip>
          //   </Menu.Item>,
          <Menu.Item
            key="NewStatistics"
            className={getMenuItemClassName(statisticsPages.newRoot)}
          >
            <Tooltip
              placement="bottom"
              title="Статистика"
            >
              <Link
                to={`/${statisticsPages.newRoot}`}
                onClick={
                  appPage === 'NewStatistics'
                    ? (e) => e.preventDefault()
                    : undefined
                }
              >
                <Icon
                  component={StatisticIcon}
                  style={menuIconStyle}
                />
              </Link>
            </Tooltip>
          </Menu.Item>,
        ]}
      {userInfo.AllowHousingStock && appMode !== 'Administrator' && (
        <Menu.Item
          key="HousingStock"
          className={getMenuItemClassName('HousingStock')}
        >
          <Tooltip
            placement="bottom"
            title="Жилой фонд"
          >
            <Link to="/HousingStock">
              <Icon
                component={HousingStockIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowTransportsAndPermits && appMode !== 'Administrator' && (
        <Menu.Item
          key="TransportPermits"
          className={getMenuItemClassName('TransportPermits')}
        >
          <Tooltip
            placement="bottom"
            title="ТС и пропуска"
          >
            <Link to="/TransportPermits">
              <Icon
                component={CarIcon}
                style={{ fontSize: 32, color: '#3378F9', marginRight: 0 }}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowMeters && appMode !== 'Administrator' && (
        <Menu.Item
          key="Meters"
          className={getMenuItemClassName('Meters')}
        >
          <Tooltip
            placement="bottom"
            title="ОДПУ"
          >
            <Link to="/Meters">
              <Icon
                component={MeterIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowDocs && appMode !== 'Administrator' && (
        <Menu.Item
          key="Documents"
          className={getMenuItemClassName('Documents')}
        >
          <Tooltip
            placement="bottom"
            title="Документы"
          >
            <Link to="/Documents">
              <Icon
                component={DocumentsIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowCalendar && appMode !== 'Administrator' && (
        <Menu.Item
          key="Calendar"
          className={getMenuItemClassName('Calendar')}
        >
          <Tooltip
            placement="bottom"
            title="Календарь"
          >
            <Link to="/Calendar">
              <Icon
                component={CalendarIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowQuestions && appMode !== 'Administrator' && (
        <Menu.Item
          key="Questions"
          className={getMenuItemClassName('Questions')}
        >
          <Tooltip
            placement="bottom"
            title="Вопросы"
          >
            <Link to="/Questions">
              <Icon
                component={QuestionsIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowInformation && appMode !== 'Administrator' && (
        <Menu.Item
          key="Informations"
          className={getMenuItemClassName('Informations')}
        >
          <Tooltip
            placement="bottom"
            title="Информирование"
          >
            <Link to="/Informations">
              <Icon
                component={InformationsIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}

      {userInfo.AllowVoting && appMode !== 'Administrator' && (
        <Menu.Item
          key="Voting"
          className={getMenuItemClassName('Voting')}
        >
          <Tooltip
            placement="bottom"
            title="Опрос"
          >
            <Link to="/Voting">
              <Icon
                component={VotingIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowDebts && appMode !== 'Administrator' && (
        <Menu.Item
          key="Debts"
          className={getMenuItemClassName('Debts')}
        >
          <Tooltip
            placement="bottom"
            title="Дебиторская задолженность"
          >
            <Link to="/Debts">
              <Icon
                component={DebtsIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowOffice && appMode !== 'Administrator' && (
        <Menu.Item
          key="Offices"
          className={getMenuItemClassName('Offices')}
        >
          <Tooltip
            placement="bottom"
            title="Офисы"
          >
            <Link to="/Offices">
              <Icon
                component={OfficesIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {props.allowCallHistory && appMode !== 'Administrator' && (
        <Menu.Item
          key="CallHistory"
          className={getMenuItemClassName('CallHistory')}
        >
          <Tooltip
            placement="bottom"
            title="История звонков"
          >
            <Link to="/CallHistory">
              <Icon
                component={CallHistoryIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {userInfo.AllowAlerts && appMode !== 'Administrator' && (
        <Menu.Item
          key="Shutdowns"
          className={getMenuItemClassName('Shutdowns')}
        >
          <Tooltip
            placement="bottom"
            title={
              <span className={styles.shutdownTooltipTitle}>
                Аварийные и плановые отключения
              </span>
            }
          >
            <Link
              to="/Shutdowns"
              onClick={
                appPage === 'Shutdowns' ? (e) => e.preventDefault() : undefined
              }
            >
              <Icon
                component={ShutdownsIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}

      {userInfo.AllowAcceptance && appMode !== 'Administrator' && (
        <Menu.Item
          key="Acceptance"
          className={getMenuItemClassName('Acceptance')}
        >
          <Tooltip
            placement="bottom"
            title="Приемки"
          >
            <Link
              to="/Acceptance"
              onClick={
                appPage === 'Acceptance' ? (e) => e.preventDefault() : undefined
              }
            >
              <Icon
                component={AcceptanceIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      
      {userInfo.EnableAdminPage && appMode !== 'Administrator' && (
        <Menu.Item
          key="Administrator"
          className={getMenuItemClassName('Administrator')}
        >
          <Tooltip
            placement="bottom"
            title="Администратор"
          >
            <Link to="/Administrator">
              <Icon
                component={GeargIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {appMode === 'Administrator' && (
        <Menu.Item
          key="AdministratorRegisteredPhones"
          className={getMenuItemClassName('AdministratorRegisteredPhones')}
        >
          <Tooltip
            placement="bottom"
            title="Телефоны"
          >
            <Link to="/AdministratorRegisteredPhones">
              <Icon
                component={HeadsetIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {appMode === 'Administrator' && (
        <Menu.Item
          key="AdministratorPersonnel"
          className={getMenuItemClassName('AdministratorPersonnel')}
        >
          <Tooltip
            placement="bottom"
            title="Персонал"
          >
            <Link to="/AdministratorPersonnel">
              <Icon
                component={BadgeIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
      {appMode === 'Administrator' && (
        <Menu.Item
          key={adminPathsRootWithoutFirstSlash}
          className={getMenuItemClassName(adminPathsRootWithoutFirstSlash)}
        >
          <Tooltip
            placement="bottom"
            title="Администрирование"
          >
            <Link to={adminPaths.root}>
              <Icon
                component={GeargIcon}
                style={menuIconStyle}
              />
            </Link>
          </Tooltip>
        </Menu.Item>
      )}
    </Menu>
  );
};

function mapStateToProps(state) {
  const { appBarStore } = state;
  const { userInfo } = state.authentication;

  return { ...appBarStore, userInfo };
}

const connectedTabBar = connect(mapStateToProps)(TabBar);
export { connectedTabBar as TabBar };
